import Api from '@/services/Api'

export default {
  show (params) {
    return Api().post('deviceTimezone', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/DeviceTimezoneService.js